module.exports = __webpack_public_path__ + "static/UV_Grid_Sm-a4a234e14a23839ae507aa420fd5fcf2.jpg";